import TableCellRaw from '@mui/material/TableCell'
import {useI18n, useIsRtl} from 'store/Store'
import {formatKeyFunctionsByType} from 'services/utils/tables'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import {IconButton} from '@mui/material'

const TableCell = ({itemKey, tableRowData, keyTypes, isRowOpenable}) => {
    const {i18n} = useI18n()
    const isRtl = useIsRtl()
    const value = tableRowData[itemKey]
    const type = keyTypes?.[itemKey]
    const displayValue =
        formatKeyFunctionsByType(tableRowData)[type]?.(value, i18n) || value

    return (
        <TableCellRaw
            align={isRtl ? 'right' : 'left'}
            component="th"
            scope="row">
            {isRowOpenable && (
                <IconButton size="small">
                    <KeyboardArrowLeftIcon />
                </IconButton>
            )}
            {displayValue}
        </TableCellRaw>
    )
}

export default TableCell
